import { NfzDepartment } from '@dreryk/egabinet-nfz-configuration-frontend-api';

import { commonTranslationKeys, createTranslatedText, FieldControllerProps } from '@dreryk/react-common';
import { Select } from '@dreryk/react-components';

import { nfzSettingsTranslationKeys } from '../../../translations';

import { useCqrsNfzDepartmentSearch } from './NfzDepartmentSelect.hooks';
import { StyledNfzDepartmentSelect } from './NfzDepartmentSelect.styled';
import { nfzDepartmentSelectFilterCreator, nfzDepartmentTriggerLabelExtractor } from './NfzDepartmentSelect.utils';

type NfzDepartmentSelectProps = FieldControllerProps<'nfzDepartment', NfzDepartment | null>;

export const NfzDepartmentSelect = (props: NfzDepartmentSelectProps): JSX.Element => {
   const { data: nfzDepartments = [] } = useCqrsNfzDepartmentSearch();

   const controller = props.register(props.name, { required: props.required });

   return (
      <StyledNfzDepartmentSelect<NfzDepartment>
         controller={controller}
         label={nfzSettingsTranslationKeys.department}
         triggerLabelExtractor={nfzDepartmentTriggerLabelExtractor}
         placeholder={commonTranslationKeys.choose}
         testId={props.name}
         defaultValue={null}
         searchInputEnabled
      >
         <Select.Filter items={nfzDepartments} filter={nfzDepartmentSelectFilterCreator}>
            {({ filteredItems }) => (
               <Select.List<NfzDepartment> items={filteredItems} keyExtractor={'id'}>
                  {(nfzDepartment) => (
                     <Select.Item
                        item={nfzDepartment}
                        label={
                           <span>
                              <Select.Highlight node={createTranslatedText(nfzDepartment.name)} />
                              <span>
                                 {' ('}
                                 <Select.Highlight node={createTranslatedText(nfzDepartment.code)} />
                                 {')'}
                              </span>
                           </span>
                        }
                        testId={nfzDepartment.id}
                     />
                  )}
               </Select.List>
            )}
         </Select.Filter>
      </StyledNfzDepartmentSelect>
   );
};
